// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
import { LoginResponseFragmentDoc } from './fragments/loginResponse.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const LoginDocument = gql`
    mutation login($credentials: CredentialsInput!, $locale: Locale!, $isConsultant: Boolean!) {
  login(credentials: $credentials) {
    ...loginResponse
  }
}
    ${LoginResponseFragmentDoc}`;

export function useLoginMutation() {
  return Urql.useMutation<SchemaTypes.LoginMutation, SchemaTypes.LoginMutationVariables>(LoginDocument);
};